import "core-js/modules/es7.array.includes";
import _Map from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/map";
import "core-js/modules/es6.function.name";
import router from "@/router/router";
import Vue from "vue";
import { i18n } from "@/i18n/i18n-setup"; // declare const Toast: any;

var getCurrentRouterName = function getCurrentRouterName() {
  return router.history ? router.history.current.name : "";
}; //======================= Kill App =========================


var killAppRouterName = ["home"];
var killAppInfoTimer = null;
var killAppCount = 0;

var killAppInfo = function killAppInfo(fn) {
  if (killAppCount >= 1) {
    fn && fn();
    navigator.app.exitApp();
    clearTimeout(killAppInfoTimer);
  }

  killAppCount += 1;
  Vue.prototype.$toast({
    message: i18n.t("common.button.out_app"),
    duration: 2000,
    position: "bottom"
  });
  killAppInfoTimer = setTimeout(function () {
    killAppCount = 0;
  }, 1000);
}; //====================== Map Fn =========================


var statckFn = new _Map();
export var DIALOG_KEY = "DIALOG_KEY";
export var VIP_CLOSE_TOAST = "VIP_CLOSE_TOAST";

var runBackPressFn = function runBackPressFn() {
  // 执行安卓的返回
  console.log("runBackPressFn", {
    statckFn: statckFn,
    router: router
  });

  if (statckFn.has(DIALOG_KEY)) {
    statckFn.get(DIALOG_KEY)();
    return;
  }

  if (statckFn.has(VIP_CLOSE_TOAST)) {
    statckFn.get(VIP_CLOSE_TOAST)();
    return;
  } // console.log("getCurrentRouterName:", getCurrentRouterName());


  if (statckFn.has(getCurrentRouterName())) {
    statckFn.get(getCurrentRouterName())();
    return;
  } // console.log("getCurrentRouterName:", getCurrentRouterName());


  if (killAppRouterName.includes(getCurrentRouterName())) {
    //如果包含了主页面的路由需要提示是否关闭App
    killAppInfo();
  }
}; //====================== Back Press Class ===============


export default {
  initial: function initial() {
    document.addEventListener("backbutton", runBackPressFn, false);
  },
  listen: function listen(data) {
    var key = data.key,
        fn = data.fn;
    statckFn.set(key, fn); // console.log("listen statckFn:", statckFn);
  },
  destroy: function destroy(key) {
    statckFn.has(key) ? statckFn.delete(key) : void 0;
    console.log("destroy statckFn:", {
      key: key,
      statckFn: statckFn
    });
  }
};